import React, { useEffect } from 'react';
import { LoaderIcon } from '@repo/icons';
import StateBasedFadeTransition from '@components/transitions/StateBasedFadeTransition';

export default function DelayedLoader({
  width = 12,
  height = 12,
  delay = 150,
  loading,
}: {
  width?: number;
  height?: number;
  delay?: number;
  loading: boolean;
}) {
  const [showLoader, setShowLoader] = React.useState(false);

  useEffect(() => {
    if (loading) {
      const timeout = setTimeout(() => {
        setShowLoader(true);
      }, delay);
      return () => clearTimeout(timeout);
    } else {
      setShowLoader(false);
      return () => {};
    }
  }, [loading]);

  return (
    <StateBasedFadeTransition
      state={String(showLoader)}
      elementByStateMap={{
        true: <LoaderIcon width={width} height={height} />,
        false: <span />,
      }}
      duration="fast"
    />
  );
}
